import React, { ChangeEvent } from 'react';
import { Button, Drawer, Grid, Skeleton, Typography } from '@mui/material';
import { PageContentDto } from '../../../../services/dtos/page-content.dto';
import logo_service from '../../../../assets/images/logo-sddea.png';
import MovingInBillForm from '../../../../components/forms/moving-in/moving-in-bill/moving-in-bill.form';
import { ImageAdmin } from '../../../commun/image-admin';

//Props d'entrée de la fonction ContractAttachementForm
type Props = {
    handlerChangeBill: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    handlerNavigate: () => void;
    pageContent: PageContentDto;
    loading: boolean;
    billRadioValue: string;
};

/**
 * Page de rattachement de contrat
 * @constructor
 */
function MovingInBillUi({ handlerChangeBill, handlerNavigate, pageContent, loading, billRadioValue }: Props) {
    // Gestion de l'état du drawer
    const [drawerOpened, setDrawerOpened] = React.useState(false);
    // Gestion de l'ouverture du Drawer
    const toggleDrawer = (open: boolean) => () => {
        setDrawerOpened(open);
    };

    return (
        <Grid container spacing={2}>
            {/*Titre de la page*/}
            <Grid item xs={12} sx={{ marginTop: '10px' }}></Grid>
            {/*Affichage de l'image dans un drawer pour les écrans mobile*/}
            <Grid item xs={12} sx={{ display: { xs: 'flex', md: 'none' } }}>
                {loading ? (
                    // Skeleton pour le chargement de l'image, rend indispo le drawer tant que l'image est pas récupérée
                    <Skeleton variant="text">
                        <Button onClick={toggleDrawer(true)}>Voir un exemple de facture</Button>
                    </Skeleton>
                ) : (
                    pageContent?.image && (
                        <>
                            <Button onClick={toggleDrawer(true)}>Voir un exemple de facture</Button>
                            <Drawer open={drawerOpened} anchor={'bottom'} onClose={toggleDrawer(false)}>
                                <ImageAdmin
                                    className="image-contract"
                                    src={pageContent.image}
                                    alt="Une facture du SDDEA"
                                />
                            </Drawer>
                        </>
                    )
                )}
            </Grid>
            {/*Formulaire*/}
            <Grid item md={6} xs={12}>
                <Typography variant="h4">{pageContent.title}</Typography>
                <MovingInBillForm
                    handlerChangeBill={handlerChangeBill}
                    handlerNavigate={handlerNavigate}
                    radioValue={billRadioValue}
                />
            </Grid>
            {/*Affichage de l'image sur le côté du formulaire pour les écrans normaux*/}
            <Grid item md={6} sx={{ display: { xs: 'none', md: 'flex' } }}>
                {loading ? (
                    <Skeleton variant="rectangular">
                        <img className="image-contract" src={logo_service} alt="Placeholder de chargement" />
                    </Skeleton>
                ) : (
                    pageContent?.image && (
                        <ImageAdmin alt="Une facture du SDDEA" src={pageContent.image} className="image-contract" />
                    )
                )}
            </Grid>
        </Grid>
    );
}

export default MovingInBillUi;
